import React from 'react';
import { withRouter } from 'react-router';

let globalHistory = null;

class BrowserHistory extends React.Component {
  constructor(props) {
    super(props)
    globalHistory = props.history; 
  }

  componentDidUpdate() {
    globalHistory = this.props.history;
  }

  render(){
    return null;
  }
}

export const GlobalHistory = withRouter(BrowserHistory);

export default function getHistory() {    
  return globalHistory;
}